module.exports = __webpack_public_path__ + "img/Otp-guide-screen-1.1b62ef34.png";